import React from "react";
import styled from "@emotion/styled";

const GraphsSection = styled.section`
  padding: 80px 0 60px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardsContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  justify-items: center;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const GraphContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const GraphTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 40px;
  color: #335da9;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: relative;
  padding-bottom: 15px;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 3px;
    background: linear-gradient(90deg, #4caf50, #45a049);
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 12px;
`;

const GraphImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;

  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
`;

const Graphs = () => {
  const images = ["a20.png", "a10.png", "a30.png", "a40.png"];

  return (
    <GraphsSection>
      <GraphTitle>Analytics Dashboard</GraphTitle>
      <CardsContainer>
        {images.map((image, index) => (
          <GraphContainer key={index}>
            <ImageWrapper>
              <GraphImage
                src={`/images/${image}`}
                alt={`Analytics ${index + 1}`}
              />
            </ImageWrapper>
          </GraphContainer>
        ))}
      </CardsContainer>
    </GraphsSection>
  );
};

export default Graphs;
